import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

export default {
  computed: {
    fields() {
      return [
        {
          label: 'No Pengiriman',
          key: 'number',
          isShow: true,
          isLocked: true,
        },
        {
          label: 'Status',
          key: 'status.name',
          isShow: true,
          isLocked: true,
        },
        {
          label: 'Pelanggan Penerima',
          key: 'shipped_customer.name',
          isShow: true,
        },
        {
          label: 'Vendor',
          key: 'vendor.name',
          isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
        },
        {
          label: 'Alamat Asal',
          key: 'origin_address.name',
          isShow: true,
        },
        {
          label: 'Alamat Tujuan',
          key: 'destination_address.name',
          isShow: true,
        },
        {
          label: 'No. Penugasan',
          key: 'fleet_task.number',
          isShow: true,
        },
        {
          label: 'Plat Nomor',
          key: 'fleet_task.vehicle.license_plate',
          isShow: true,
        },
        {
          label: 'Pengemudi',
          key: 'fleet_task.driver_user.name',
          isShow: true,
        },
        {
          label: 'Dibuat',
          key: 'created_on',
          isShow: true,
        },
        {
          label: 'Dikonfirmasi',
          key: 'confirmed_on',
          isShow: true,
        },
        {
          label: 'Dijadwalkan',
          key: 'scheduled_on',
          isShow: true,
        },
        {
          label: 'Dijalankan',
          key: 'started_on',
          isShow: true,
        },
        {
          label: 'Diambil',
          key: 'picked_on',
          isShow: true,
        },
        {
          label: 'Terkirim',
          key: 'delivered_on',
          isShow: true,
        },
        {
          label: 'Total Waktu Pengiriman',
          key: 'delivered_duration',
          isShow: true,
        },
      ]
    } 
  }
}